import React, {Component} from "react";
import {Col, Row, Tabs} from "antd";
import {Link, withRouter} from "react-router-dom";
import MailIcon from "../icons/MailIcon";
import Title from "antd/es/typography/Title";
import Text from "antd/es/typography/Text";
import BrdgxButton from "./BrdgxButton";


class FinalReviewForm extends Component {


    render() {
        return (
            <div>
                <Row gutter={24}>
                    <Col span={4}></Col>
                    <Col span={16}>
                        <div className="submitted-panel-wrapper">
                            <div style={{marginBottom: "5%"}}>
                                <MailIcon/>
                            </div>
                            <Title level={3}>Account Verification Details Submitted</Title>
                            <Text className="submitted-panel-desc">
                                Our team is reviewing your information. Once complete, you will
                                receive an email within 24 hours.
                            </Text>
                            {/*<Title level={3} style={{marginBottom: "5%"}}>*/}
                            {/*    Verification Status*/}
                            {/*</Title>*/}
                            {/*<Text style={{color: "#4A4A4A", fontSize: 24}}>*/}
                            {/*    Under Review*/}
                            {/*</Text>*/}


                            <div
                                style={{
                                    height: 1,
                                    width: "80%",
                                    backgroundColor: "#3D77BC"

                                }}
                            />
                            <BrdgxButton
                                style={{marginBottom: "5%", width: "80%"}}
                                title="Go To Dashboard"
                                onClick={() => this.props.history.push("/")}
                            />
                            <Text style={{marginBottom: "10%"}}>
                                Need help? &nbsp;
                                <a href="https://web.whatsapp.com/send?phone=6591729552&text=Chat with Brdgx business team" target="_blank">
                                Contact Us
                                </a>
                            </Text>
                        </div>
                    </Col>
                    <Col span={4}></Col>

                </Row>
            </div>
        )
    }
}
export default withRouter(FinalReviewForm);